(function ($) {
    $.getAntiForgeryToken = function (tokenWindow, appPath) {
        tokenWindow = tokenWindow && typeof tokenWindow === typeof window ? tokenWindow : window;
        appPath = appPath && typeof appPath === "string" ? "_" + appPath.toString() : "";
        var tokenName = "__RequestVerificationToken" + appPath;
        var inputElements = tokenWindow.document.getElementsByTagName("input");
        for (var i = 0; i < inputElements.length; i++) {
            var inputElement = inputElements[i];
            if (inputElement.type === "hidden" && inputElement.name === tokenName) {
                return {
                    name: tokenName,
                    value: inputElement.value
                };
            }
        }
    };
    $.getFormatedAntiForgeryToken = function () {
        var token = $.getAntiForgeryToken();
        return { [encodeURIComponent(token.name)]: encodeURIComponent(token.value) };
    };
    $.appendAntiForgeryToken = function (data, token) {
        if (data && typeof data !== "string") {
            data = $.param(data);
        }
        token = token ? token : $.getAntiForgeryToken();
        data = data ? data + "&" : "";
        return token ? data + encodeURIComponent(token.name) + "=" + encodeURIComponent(token.value) : data;
    };
    $.postAf = function (url, data, callback, type) {
        return $.post(url, $.appendAntiForgeryToken(data), callback, type);
    };
    $.ajaxAf = function (settings) {
        var token = settings.token ? settings.token : $.getAntiForgeryToken(settings.tokenWindow, settings.appPath);
        settings.data = $.appendAntiForgeryToken(settings.data, token);
        return $.ajax(settings);
    };
})(jQuery);